import React from 'react';

const App = () => {
  return (
    <div>
      <meta charSet="UTF-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>Document</title>
      <style
        dangerouslySetInnerHTML={{
          __html:
            '\n      .loader {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        min-height: 100vh;\n      }\n      .loader svg {\n        /* edit for loader dimensions */\n        height: 200px;\n        width: 200px;\n      }\n      .loader svg path {\n        animation-name: draw;\n        animation-duration: 3s;\n        animation-iteration-count: infinite;\n      }\n      @keyframes draw {\n        35% {\n          stroke-dashoffset: 0;\n        }\n        40% {\n          stroke-dashoffset: 0;\n        }\n        50% {\n          stroke-dashoffset: 0;\n        }\n      }\n    ',
        }}
      />
      <div className="loader" data-testid="loader">
        <svg
          width={104}
          height={29}
          viewBox="0 0 104 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.605844 2.03434C0.969157 1.67099 1.48587 1.48231 1.99814 1.48271C3.0691 1.48351 4.14047 1.48431 5.21184 1.48231C4.68665 2.02672 4.13805 2.5487 3.606 3.08671C2.40424 4.27609 1.20531 5.46907 0.00435953 6.65925C-0.00411777 5.59205 0.00355254 4.52486 0.000323089 3.45766C-0.00976893 2.92647 0.2171 2.39848 0.605844 2.03434Z"
            stroke="#00E59E"
          />
          <path
            d="M11.0909 1.4851C12.8098 1.4819 14.5287 1.4855 16.2476 1.4831C14.0463 3.68199 11.8313 5.86765 9.62679 8.06293C6.41631 11.2457 3.2127 14.4352 0.000610352 17.616C0.00141771 15.9078 0.00101403 14.2001 0.000610352 12.4919C3.69833 8.82407 7.39685 5.15619 11.0909 1.4851Z"
            stroke="#00E59E"
          />
          <path
            d="M0.00221347 23.3987C7.36414 16.0946 14.7188 8.78286 22.0832 1.48116C23.2207 1.48516 24.3587 1.48236 25.4963 1.48236C25.9811 1.48075 26.47 1.643 26.8329 1.96828C27.2503 2.32482 27.507 2.86442 27.5006 3.41284C27.5014 11.1184 27.501 18.8239 27.501 26.5294C27.4997 26.7441 27.5086 26.96 27.4779 27.1739C27.3794 27.7119 27.0468 28.1999 26.5777 28.4875C26.2237 28.715 25.7934 28.7952 25.3768 28.7847C24.24 28.7867 23.1029 28.7811 21.9661 28.7875C20.4983 27.3482 19.0459 25.8928 17.5833 24.4479C15.3889 22.2694 13.1913 20.0946 10.9981 17.9149C10.6998 18.1765 10.4349 18.4757 10.1491 18.7518C9.4984 19.4075 8.84121 20.0569 8.1929 20.7151C10.3558 22.8663 12.5091 25.0267 14.6724 27.1775C15.2052 27.7151 15.7502 28.2415 16.2754 28.7859C14.4637 28.7827 12.6524 28.7867 10.841 28.7843C9.04345 26.9736 7.24828 25.1609 5.45231 23.3494C4.53111 24.2888 3.61516 25.233 2.69154 26.17C3.16667 26.6315 3.64987 27.0854 4.12137 27.5509C4.54847 27.9599 4.98081 28.3641 5.39579 28.7851C4.2776 28.7847 3.1594 28.7843 2.04121 28.7855C1.52449 28.7924 1.00011 28.6141 0.626708 28.2531C0.238367 27.8958 0.00181002 27.3782 0.00181002 26.8515C0.00181002 25.7005 0.00140611 24.5496 0.00221347 23.3987Z"
            stroke="#00E59E"
          />
          <path
            d="M52.3258 1.26949H45.4498L38.9336 10.2353V1.26949H33.017V28.6033H38.9336V19.3201L47.2088 28.6033H54.8044L41.8918 14.7975L52.3258 1.26949Z"
            stroke="#18379A"
          />
          <path
            d="M66.8841 19.8755C66.8841 22.4542 65.4449 23.6443 63.526 23.6443C61.887 23.6443 60.2079 22.6129 60.2079 19.9549V10.0766H54.6511C54.6511 10.0766 54.6511 16.067 54.6511 21.145C54.6511 26.223 57.6894 29 62.0469 29C63.9258 29 65.9246 27.8495 66.8841 26.0643V28.6033H72.4409V10.0766H66.8841V19.8755Z"
            stroke="#18379A"
          />
          <path
            d="M89.5058 19.2804C89.5058 21.8591 87.5869 23.7633 85.1883 23.7633C82.7897 23.7633 80.8708 21.9781 80.8708 19.2804C80.8708 16.7018 82.7897 14.8769 85.1883 14.8769C87.5869 14.8769 89.5058 16.5828 89.5058 19.2804ZM95.1426 0H89.6258V12.3379C88.7063 10.7114 86.5475 9.67989 84.1489 9.67989C81.6703 9.67989 79.5516 10.5923 77.7526 12.3776C75.9936 14.1628 75.1141 16.5034 75.1141 19.3995C75.1141 22.2161 75.9936 24.5568 77.7526 26.342C79.5516 28.1272 81.6703 29 84.1489 29C86.5475 29 88.7063 28.0082 89.6258 26.3023V28.6033H95.1426V0Z"
            stroke="#18379A"
          />
          <path
            d="M97.8435 10.0766V28.6033H103.36V10.0766H97.8435ZM100.602 0C98.683 0 97.1239 1.42818 97.1239 3.21341C97.1239 4.99863 98.683 6.46648 100.602 6.46648C102.481 6.46648 104 4.99863 104 3.21341C104 1.42818 102.481 0 100.602 0Z"
            stroke="#18379A"
          />
        </svg>
      </div>
    </div>
  );
};

export default App;
